import React from 'react';
import { StarIcon, UsersIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="py-12 bg-[#F5EDE3] border-y border-[#3D2B1F]/10" data-id="element-169">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-170">
        <div className="flex justify-center items-center gap-1 mb-4" data-id="element-171">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-[#C67B30] text-[#C67B30]" data-id="element-172" />)}
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-[#6B5344] text-lg md:text-xl font-medium" data-id="element-173">
          <div className="flex items-center gap-2 bg-[#C67B30]/10 px-4 py-2 rounded-full" data-id="element-174">
            <UsersIcon className="w-5 h-5 text-[#C67B30]" data-id="element-175" />
            <span className="font-bold text-[#3D2B1F]" data-id="element-176">+2,500</span> alumnos
          </div>
          <p className="max-w-2xl" data-id="element-177">
            Miles de personas ya están descubriendo lo fácil que es transformar
            un budín simple en un postre espectacular.
          </p>
        </div>
      </div>
    </section>;
}